import { connect } from 'react-redux';
import { branch, compose, renderNothing } from 'recompact';

import { errorBoundary } from 'src/app/hocs';
import type { RootState } from 'src/app/state/store';

import Renderer from '.';

function makeMapStateToProps() {
  return (state: RootState) => {
    const modalType = state?.modal?.modalType;
    return {
      modalType,
    };
  };
}

const mapDispatchToProps = () => ({});

export default compose(
  errorBoundary,
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(({ modalType }) => !modalType, renderNothing)
)(Renderer);
